/**
 * GENERATED FILE. Do not edit.
 *
 * Written by `nx run landing-blog:content` from content/blog/. Edit the
 * markdown, not this.
 */
/** `<lang>:<slug>` to the post's rendered HTML, one chunk each. */
export const BODIES: Record<string, () => Promise<{ html: string }>> = {
  "en:budget-categories-percentages": () => import('./posts/en/budget-categories-percentages'),
  "en:how-to-track-your-expenses": () => import('./posts/en/how-to-track-your-expenses'),
  "en:offline-budget-app": () => import('./posts/en/offline-budget-app'),
  "en:free-budget-app": () => import('./posts/en/free-budget-app'),
  "en:budget-app-android": () => import('./posts/en/budget-app-android'),
  "en:personal-budget-app": () => import('./posts/en/personal-budget-app'),
  "en:paycheck-budget-app": () => import('./posts/en/paycheck-budget-app'),
  "en:budget-app-for-couples": () => import('./posts/en/budget-app-for-couples'),
  "en:budget-app-for-iphone": () => import('./posts/en/budget-app-for-iphone'),
  "en:cash-flow-tracker": () => import('./posts/en/cash-flow-tracker'),
  "en:data-backup-best-practices": () => import('./posts/en/data-backup-best-practices'),
  "en:what-is-budget-planning": () => import('./posts/en/what-is-budget-planning'),
  "en:how-to-track-your-net-worth": () => import('./posts/en/how-to-track-your-net-worth'),
  "en:net-worth-tracking-spreadsheet": () => import('./posts/en/net-worth-tracking-spreadsheet'),
  "en:tracking-credit-card-payments": () => import('./posts/en/tracking-credit-card-payments'),
  "en:how-to-budget-with-irregular-income": () => import('./posts/en/how-to-budget-with-irregular-income'),
  "en:are-budgeting-apps-worth-it": () => import('./posts/en/are-budgeting-apps-worth-it'),
  "en:ledgerly-vs-ynab": () => import('./posts/en/ledgerly-vs-ynab'),
  "en:what-happened-to-mint-users": () => import('./posts/en/what-happened-to-mint-users'),
  "fr:ynab-alternatives-without-bank-login": () => import('./posts/fr/ynab-alternatives-without-bank-login'),
  "en:what-does-export-to-csv-mean": () => import('./posts/en/what-does-export-to-csv-mean'),
  "en:day-to-day-expenses-app": () => import('./posts/en/day-to-day-expenses-app'),
  "en:best-budget-apps-without-bank-linking": () => import('./posts/en/best-budget-apps-without-bank-linking'),
  "fr:best-budget-apps-without-bank-linking": () => import('./posts/fr/best-budget-apps-without-bank-linking'),
  "en:ynab-alternatives-without-bank-login": () => import('./posts/en/ynab-alternatives-without-bank-login'),
};
